import React from 'react';
import PropTypes from 'prop-types';
import { View } from 'react-native';

import { pure } from '@dbk/ui-react-utils';

import styles from './table-row.styles';

function TableRowColumn(props) {
  const { align, children, width, wrap, gutter, testID, alignIE } = props;
  const alignStyles = align === 'left' ? null : styles.rightAlignColumn;
  const gutterStyles = gutter ? styles.columnInner : null;

  return (
    <View
      style={[
        alignStyles,
        (width === undefined ? styles.column : null),
        (width ? { flex: width, flexBasis: 0 } : null),
        (!wrap) ? { flexGrow: 2 } : null,
      ]}
    >
      <View style={gutterStyles} testID={testID} className={alignIE ? "ie-alignitems-stretch" : ""} >
        {children}
      </View>
    </View>
  );
}

TableRowColumn.propTypes = {
  align: PropTypes.string,
  width: PropTypes.number,
  gutter: PropTypes.bool,
  children: PropTypes.node,
  testID: PropTypes.string,
  wrap: PropTypes.bool,
  alignIE: PropTypes.bool,
};

TableRowColumn.defaultProps = {
  align: 'right',
  gutter: true,
  testID: 'data',
  wrap: true,
  alignIE: false,
};

export default pure(TableRowColumn);
